(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import Loading from "../../../../components/Loading";
import styles from "./ExplanatoryNotes.module.css";
import Badge from "../../../../components/Badge/Badge";

const ExplanatoryNotes = props => {
  const {
    html,
    isLoading,
    hsCodeLevel2,
    isRtl,
    colors,
    hasError
  } = props;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: styles.codes
  }, /*#__PURE__*/React.createElement("li", {
    className: styles.code
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.codeLabel
  }, t("CHAPTER")), /*#__PURE__*/React.createElement("div", {
    className: styles.codeDesc
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.badge
  }, /*#__PURE__*/React.createElement(Badge, {
    color: colors.secondary
  }, hsCodeLevel2 && hsCodeLevel2.code)), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.codeDescTitle, {
      [styles.rtl]: isRtl
    })
  }, hsCodeLevel2 && hsCodeLevel2.description)))), isLoading && /*#__PURE__*/React.createElement("div", {
    className: styles.center
  }, /*#__PURE__*/React.createElement(Loading, {
    color: colors.success
  })), html ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  React.createElement("div", {
    className: cx(styles.container, {
      [styles.rtl]: isRtl
    }),
    dangerouslySetInnerHTML: {
      __html: html
    }
  }) : null, hasError && /*#__PURE__*/React.createElement("div", {
    className: styles.errorContainer
  }, t("Notes are not available")));
};

__signature__(ExplanatoryNotes, "useTranslation{{ t }}", () => [useTranslation]);

ExplanatoryNotes.propTypes = {
  html: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  hsCodeLevel2: PropTypes.object,
  isRtl: PropTypes.bool,
  colors: PropTypes.shape({
    info: PropTypes.string,
    success: PropTypes.string,
    secondary: PropTypes.string
  }).isRequired,
  hasError: PropTypes.bool
};
ExplanatoryNotes.defaultProps = {
  isLoading: false,
  hasError: false,
  isRtl: false,
  hsCodeLevel2: null
};

const _default = /*#__PURE__*/React.memo(ExplanatoryNotes);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ExplanatoryNotes, "ExplanatoryNotes", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/ExplanatoryNotes/ExplanatoryNotes.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/ExplanatoryNotes/ExplanatoryNotes.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();